import { updateState } from "../../redux/commonSlice";
import { setSnackbar } from "../../redux/messageSlice";
import { updateReviewState } from "../../redux/reviewSlice";
import { createRevision, createRevisionLogs, deleteRevisionLogApi, disableRevisionTutorial, getRevisionLogsApi, submitRevision } from "../../services/api";
import { showSnackBar } from "../../utils/commonServices";
import { getEventDetails } from "../events/actions";
import { PERMISSION } from "../../constants/constants";

///////////////////////////////// POST API REQ TO CREATE NEW REVISION REQUEST ///////////////////////////////

export const createNewRevision = (dispatch, navigate, state , payload) => {

    // console.log('🔧 createNewRevision called:', {
    //   event_id: payload?.event_id,
    //   final_video_id: payload?.final_video_id,
    //   permissionsReducer: state?.permissionsReducer,
    //   permissions_master: state?.permissionsReducer?.permissions_master
    // });

    // Safety checks: double-guard here to avoid unwanted create calls
    try {
      const finalVideoExists = !!payload?.final_video_id;
      // Prefer latest info if available on state.commonReducer.event_details, otherwise fall back to true
      const revisionEnabled = (state?.commonReducer?.event_details?.enable_revision !== undefined) ? state.commonReducer.event_details.enable_revision !== false : true;
      // Check if there's a revision in progress FOR THE CURRENT FINAL VIDEO
      const isRevisionForCurrentVideo = state?.commonReducer?.event_details?.revision?.revision_video_id === payload?.final_video_id;
      const revisionUnderEdit = !!(state?.commonReducer?.event_details?.revision?.id && state?.commonReducer?.event_details?.revision?.submitted === false && isRevisionForCurrentVideo);
      const revisionAllowedByCount = (state?.commonReducer?.event_details?.revision_left > 0) || state?.commonReducer?.event_details?.unlimited_revision === true;
      const isCurrentEvent = state && state.commonReducer && (state.commonReducer.production_event_id == payload?.event_id);
      const hasCreatePermission = state && state.permissionsReducer && state.permissionsReducer.permissions_master && state.permissionsReducer.permissions_master[PERMISSION.PROJECT.REVISION.REQUEST.CREATE];
      // A revision can only be created while the project is in Review; outside it
      // the server answers 422 "No further Revision changes are allowed!!!".
      // This effect runs on every mount, so without the guard a finished project
      // would greet its owner with that error every time they open the page.
      const isInReview = !state?.commonReducer?.event_details?.status_type || state.commonReducer.event_details.status_type === 'Review';

      // console.log('🔍 Permission check details:', {
      //   hasCreatePermission,
      //   permissions_master_exists: !!state?.permissionsReducer?.permissions_master,
      //   permission_key: PERMISSION.PROJECT.REVISION.REQUEST.CREATE,
      //   permission_value: state?.permissionsReducer?.permissions_master?.[PERMISSION.PROJECT.REVISION.REQUEST.CREATE]
      // });

      if (!finalVideoExists || !revisionEnabled || !revisionAllowedByCount || revisionUnderEdit || !isCurrentEvent || !hasCreatePermission || !isInReview) {
        // console.info('❌ createNewRevision skipped', {
        //   event_id: payload?.event_id,
        //   finalVideoExists,
        //   revisionEnabled,
        //   revisionAllowedByCount,
        //   revisionUnderEdit,
        //   isCurrentEvent,
        //   hasCreatePermission,
        // });
        return; // don't call API
      }

      // console.info('✅ createNewRevision proceeding - calling API', { event_id: payload?.event_id, final_video_id: payload?.final_video_id });
    } catch (e) {
      // if checks fail for some reason, prevent auto-create
      console.warn('createNewRevision safety checks failed', e);
      return;
    }

    //const data = {event_id: payload.event_id, final_video_id: payload.final_video_id}
  
    createRevision(payload)
    .then((response) => {
        if (response) {
            const responseObject = response?.data;
            const responseData = responseObject?.data
            if (responseObject?.http_code == 200) {
              disableRevisionTutorialRequest(dispatch, navigate, state);
              // request_changes is now handled by useEffect in index.js
              // dispatch(updateReviewState({request_changes: true}))
              // Fetch updated event details to get the new revision
              getEventDetails({id: payload.event_id}, dispatch, navigate, state)
             // setCreateRevisionStatus("success");
            }
        }
    })
    .catch((error) => { 
     if (error) {
        const errorObject = error?.response?.data;
        showSnackBar(dispatch, errorObject)
       // dispatch(setSnackbar({type:'error', flag:true, message: 'error'}))
        // 422 "Revisions can only be requested on the latest video!!!" or "No further
        // Revision changes are allowed!!!": the page is behind the server, so reload
        // the project to show the latest cut and its current status
        if (error?.response?.status === 422) {
          getEventDetails({id: payload.event_id}, dispatch, navigate, state)
        }
      }
    });
}


///////////////////////////////// POST API REQ TO CREATE REVISION LOGS ///////////////////////////////

export const createRevisionLog = (dispatch, navigate, state, payload, successCallback  ) => {

    // Prevent creating logs against already-submitted revisions
    try {
      const isSubmitted = state?.commonReducer?.event_details?.revision?.submitted === true;
      if (isSubmitted) {
        console.info('createRevisionLog skipped: revision already submitted', { event_id: state?.commonReducer?.production_event_id })
        dispatch(setSnackbar({ type: 'error', flag: true, message: 'Cannot create logs for a submitted revision.' }))
        return;
      }
    } catch (e) {
      // proceed conservatively if state is malformed
    }

    // const data = {event_id: payload.event_id, final_video_id: payload.final_video_id}
  
    createRevisionLogs(payload)
    .then((response) => {
        if (response) {
            const responseObject = response?.data;
            const responseData = responseObject?.data
            if (responseObject?.http_code == 200) {
              successCallback();  
              getRevisionLogs(dispatch, navigate, state, payload)
            }
        }
    })
    .catch((error) => { 
     if (error) {
        const errorObject = error?.response?.data;
        showSnackBar(dispatch, errorObject)
      }
    });
}


///////////////////////////////// POST API REQ TO SUBMIT REVISION ///////////////////////////////

export const submitRevisionRequest = (dispatch, navigate, state, payload, successCallback ) => {
  
    submitRevision(payload)
    .then((response) => {
        if (response) {
            getEventDetails({id: state.commonReducer.production_event_id}, dispatch)
            successCallback()
            dispatch(updateReviewState({revision_logs: []})) 
            dispatch(updateState({new_video: false}))
           // setSubmitRevisionStatus("success");
        }
    })
    .catch((error) => { 
     if (error) {
        const errorObject = error?.response?.data;
        showSnackBar(dispatch, errorObject)
      }
    });
}


/////////////////////////////////PUT API to disable auto open revision tutorial poopup///////////////////////////////

export const disableRevisionTutorialRequest = (dispatch, navigate, state ) => {
  
    disableRevisionTutorial()
    .then((response) => {
        if (response) {
            dispatch(updateState({show_revision_tutorial: false}));
        }
    })
    .catch((error) => { 
     if (error) {
        const errorObject = error?.response?.data;
        showSnackBar(dispatch, errorObject)
      }
    });
}


///////////////////////////////// API TO GET REVISION LOGS ///////////////////////////////

export const getRevisionLogs = (dispatch, navigate, state, payload ) => {
    dispatch(updateReviewState({is_loading: true}))
    const data = {revision_id: state.commonReducer.event_details.revision?.id }
  
    getRevisionLogsApi(data)
    .then((response) => {
        dispatch(updateReviewState({is_loading: false}))
        if (response) {
            dispatch(updateReviewState({revision_logs: response?.data?.data?.revision_logs }))
        }
    })
    .catch((error) => { 
        dispatch(updateReviewState({is_loading: false}))
     if (error) {
        const errorObject = error?.response?.data;
        showSnackBar(dispatch, errorObject)
      }
    });
}


export const deleteLog = (values ,dispatch, callback) => {
  const payload = values
  deleteRevisionLogApi(payload) 
  .then((response) => {
    if(response?.data?.http_code === 200){
       callback && callback()
      dispatch(setSnackbar({type:'success', flag:true, message: response?.data?.message}))
    }else {
        dispatch(setSnackbar({type:'error', flag:true, message: 'some error occured'}))
    }
  })
  .catch((error) => {
    if(error) {
    const errorObject = error?.response?.data;
    showSnackBar(dispatch, errorObject);
    }
  });
  }